import React from 'react';
import { string, number } from 'prop-types';
import clsx from 'clsx';
import { getUserProfileImg } from 'utils/getUserProfileImg';
import ChatBubbleIcon from 'themes/common/svg/chat-bubble.svg';

import styles from './Avatar.module.scss';

function Avatar({ avatar, className }) {
  const url = avatar !== -2 ? getUserProfileImg(avatar) : null;
  const isChatBubble = avatar === -2;

  return (
    <div
      className={clsx(styles.wrapper, className, {
        [styles.isChatBubble]: isChatBubble,
      })}
    >
      {isChatBubble ? (
        <ChatBubbleIcon className={styles.svgImage} />
      ) : (
        url && <img src={url} alt="" className={styles.image} />
      )}
    </div>
  );
}

Avatar.propTypes = {
  avatar: number,
  className: string,
};

Avatar.defaultProps = {
  avatar: -1,
  className: null,
};

export default React.memo(Avatar, () => true);
